const server =
  process.env.NODE_ENV === "development"
    ? process.env.VUE_APP_SERVER
    : location.origin;

const menu = [
  {
    text: "Home",
    to: "/",
  },
  {
    text: "Institucional",
    dropdown: [
      {
        text: "Quem Somos",
        to: "/quem-somos",
      },
      {
        text: "Missão, Visão e Valores",
        to: "/missao-visao-valores",
      },
      {
        text: "Objetivos",
        to: "/objetivos",
      },
    ],
  },
  {
    text: "Diferenciais",
    to: "/diferenciais",
  },
  {
    text: "Serviços",
    to: "/servicos",
  },
  {
    text: "Eventos",
    to: "/eventos",
  },
  {
    text: "Galeria de Fotos",
    to: "/galeria-de-fotos",
  },
  {
    text: "Contato",
    to: "/contato",
  },
  {
    text: "Trabalhe Conosco",
    to: "/trabalhe-conosco",
  },
];

export { server, menu };
